import NextLink from 'next/link';
import { getToastConfig } from '../lib/toast-config';
// import { capitalizeWords } from '../lib/utils';

function capitalizeWords(arr) {
    return arr.map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1)
    });
}

export default function Toast(props) {
    const { title, body, redirectUrl } = getToastConfig(props.page);
    const toast_color_intensity = 50;
    const faceShapeClassified = props.faceShapeClassified || [];    
    return (
    <>
    <div className={` ${props.margin ? "md:ml-8" : null} not-prose alert shadow-lg w-full ${props.full ? "mr-5" : "md:w-fit"} my-5 bg-gradient-to-r from-rose-50 via-purple-50 to-indigo-50 dark:from-indigo-500 dark:via-purple-500 dark:to-pink-500`}>
        <div className="text-left md:flex md:flex-row md:items-center dark:text-white">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="shrink-0 w-12 w-12 md:w-6 md:h-6 mr-3">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
            </svg>
            <div>
                <h3 className="font-bold mb-1 md:mb-0">{title}</h3>
                <div className="text-xs">{body}</div>
            </div>
        </div>
        <div className="flex-none md:justify-self-end">
            <NextLink
                href={{
                    pathname: redirectUrl,
                    query: {
                        ...(props.page.startsWith("face_analyzer") ? {[props.page == "face_analyzer" ? "faceShape" : "eyeShape"]: capitalizeWords(faceShapeClassified)} : {}),
                        ...(props.page == "face_analyzer/facial_feature" ? {eyeSetting: props.faceInfoParsed} : {})                        
                    }
                }}
            >                            
                <button className={`btn btn-sm btn-neutral text-white `}>Show Me</button>
            </NextLink>
        </div>
    </div>
    </>
    )
}
